import { useIsDesktop } from '@/hooks/useIsDesktop';
import { DesktopLearning } from './desktop/DesktopLearning';
import { MobileMyCourses } from './mobile/MobileMyCourses';

export function LearnerLearning() {
  return useIsDesktop() ? <DesktopLearning /> : <MobileMyCourses />;
}
